import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IPick } from 'src/app/models/IPick';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-pick',
  templateUrl: './pick.component.html',
  styleUrls: ['./pick.component.css']
})

export class PickComponent implements OnInit {

  @Input() opciones: string[] = [];
  @Input() numero_seleccionables: number = 0;
  @Input() horizontal_vertical: boolean = true;
  @Input() habilitar_boton: boolean = false;
  @Input() direction: string = 'horizontal';
  @Input() font_size_opciones: boolean = false;
  @Input() pick_bloqueado: boolean = false;
  @Output() valorSeleccionado = new EventEmitter<string[]>();

  parametros_pick: IPick = {} as IPick;
  pick_seleccionado: string[] = [];
  registroForm!: UntypedFormGroup;

  constructor(private fb: FormBuilder) {
    this.registroForm = this.fb.group({
      pickSeleccionado: ['']
    });
  }
  ngOnInit(): void {
    this.parametros_pick.opciones = this.opciones;
    this.parametros_pick.numero_seleccionables = this.numero_seleccionables;
  }
  getGridStyle(index: number): any {
    if (this.horizontal_vertical) {
      return { 'grid-column': index + 1 };
    } else {
      return { 'grid-column': '1 / span 1' };
    }
  }
  onCheckboxChange(opcion: string){
    console.log('opcion', opcion);
    if (this.pick_seleccionado.includes(opcion)) {
      this.pick_seleccionado = this.pick_seleccionado.filter(item => item !== opcion);
    } else {
      this.pick_seleccionado.push(opcion);
    }
    console.log('pick_seleccionado', this.pick_seleccionado);
    this.valorSeleccionado.emit(this.pick_seleccionado);
  }
}
